import styled from 'styled-components';

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;

    th, td {
        padding: 8px;
        text-align: left;
        border-bottom: 1px solid var(--border);
    }

    th {
        background-color: var(--surface-2);
    }

    tr:hover {
        background-color: var(--accent-bg);
    }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  margin: 20px;
  padding-bottom: 40px;
`;

export const ListContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 20px;
    margin-right: 20px;
`;

export const Error = styled.div`
  color: red;
  margin-top: 10px;
`;

export const Button = styled.button`
    display: inline-flex;
    align-items: center;
    gap: var(--space-2);
    padding: var(--space-2) var(--space-5);
    border-radius: var(--radius-md);
    font-family: var(--font-body);
    font-size: var(--text-sm);
    font-weight: 500;
    letter-spacing: 0.02em;
    cursor: pointer;
    text-decoration: none;
    border: 1px solid transparent;

    transition: color var(--transition),
      background var(--transition),
      border-color var(--transition),
      box-shadow var(--transition);

    background: ${(p) => (p.$variant === "secondary" ? "var(--surface-2)" : p.$variant === "ghost" ? "transparent" : "var(--accent)")};
    color: ${(p) => (p.$variant === "secondary" ? "var(--text)" : p.$variant === "ghost" ? "var(--text-muted)" : "#13110e")};
    border-color: ${(p) =>
      p.$variant === "secondary"
        ? "var(--border)"
        : p.$variant === "ghost"
          ? "transparent"
          : "var(--accent)"};

    &:hover {
        background: ${(p) =>
          p.$variant === "secondary"
            ? "var(--surface-3)"
            : p.$variant === "ghost"
              ? "var(--accent-bg)"
              : "var(--accent-hover)"};
        border-color: ${(p) =>
          p.$variant === "secondary"
            ? "var(--accent)"
            : p.$variant === "ghost"
              ? "transparent"
              : "var(--accent-hover)"};
        color: ${(p) =>
          p.$variant === "ghost"
            ? "var(--accent)"
            : p.$variant === "secondary"
              ? "var(--accent)"
              : "#13110e"};
        box-shadow: ${(p) => (p.$variant === "primary" || !p.$variant ? "0 0 0 3px var(--accent-bg)" : "none")};
        opacity: 1;
    }

    /* Default variant is primary; consume $variant only */
`;

export const Label = styled.label`
  font-weight: bold;
`;
